import React from "react";
import MainImage from "../../assets/Braiders/JaJas-African-Hair-Braiding-Arena-Stg_195-scaled.jpg";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";
import StarterBraider from "../../components/Braiders/StarterBraider";
import GrowthBraider from "../../components/Braiders/GrowthBraider";
import VIPBraider from "../../components/Braiders/VIPBraider";
import Brandlist from "../../components/Brandlist";
import PastWordBraids from "../../components/Braiders/PastWordBraids";
import TestimonialsSection from "../../components/Braiders/TestimonialsSection";
import BraiderFunnel from "../../components/Braiders/BraiderFunnel";

function BraidersLandPage() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F6F3F1]">
      <title>Hair Braider Website Design & Booking | Woaom Web Design</title>
      <meta
        name="description"
        content="Get a custom website for your braiding business with built‑in bookings, SEO, and marketing systems. Stand out and fill your calendar today!"
      />
        <meta
    name="keywords"
    content="hair braider website design, website for hair braiding business, hair braid booking website, braider website with appointment system, custom hair braider websites, braiding business website builder, professional braider website design, beauty business websites for braiders, women-owned braider websites, local SEO braider website, braiding salon website design, affordable hair braider websites, mobile-friendly braider websites, hair braiding site marketing system, Texas hair braider website design, Austin braider website services, Houston stitching braider site, Dallas braiding booking site, website for Austin hair braiders, SEO website for braiders, online booking site for braiders, branded site for hair braiders, braided hair portfolio website design, braider brand marketing websites, side-hustle to booked braider site, braiding business growth websites, braider web presence solution, custom site for knotless braiders, hair braiding booking integration, high-converting braider websites, braider website design packages, hair braiding business online, professional site for braiders, website for natural hair braiders, braiding service website design, custom site for box braiders, hair braiding appointment website, braider site with payment system, upscale braider websites, hair braiding business branding"
  />

      {/* Hero Section */}
      <section className="bg-[#F6F3F1]">
        <div
          className="relative h-auto bg-cover bg-center object-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
                {/* Overlay */}
  
          <NavLite />
          

          {/* Hero copy overlay */}
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10 md:py-40 py-56">
            <div className="max-w-3xl bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg">
              <p className="uppercase text-xs tracking-widest text-black mb-2">for professional braiders</p>
              <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
                Make booking braids as easy as ordering food online.
              </h1>
              <p className="mt-3 text-gray-700 md:text-lg">
                Get a website that books clients for you, grows your brand, and helps you stand out.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="#packages">
                  <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
                    View Packages →
                  </button>
                </a>
                <a href="https://cal.com/woaomwebdesign/15min " target="_blank" rel="noopener noreferrer">
                  <button className="bg-white text-gray-900 border border-gray-300 rounded-lg px-6 py-3 text-sm hover:bg-gray-50 transition-colors">
                    Free 15‑min Consult 
                  </button>
                </a>
              </div>
              <p className="mt-4 text-sm text-gray-600">
                Trusted by braiders in Austin, Houston, Dallas, and beyond.
              </p>
            </div>
          </div>
        </div>

      

        {/* Intro */}
        <div className="mx-auto max-w-7xl px-5 py-10 md:px-10 text-center">
          <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">
            Best Websites for Braiders
          </p>
          <h2 className="mb-4 text-3xl md:text-5xl text-black">
            Websites for Braiders Who Want to Grow
          </h2>
          <p className="mx-auto mb-5 max-w-3xl text-sm text-gray-600 sm:text-xl">
            At Woaom Web Design, we create websites and marketing systems that help braiders look professional,
            attract more clients, and grow with confidence.
          </p>
        </div>

        {/* Packages */}
        <div id="packages" className="scroll-mt-24">
          <StarterBraider />
          <GrowthBraider />
          <VIPBraider />
        </div>

        {/* Why Choose Section */}
        <div className="mx-auto max-w-5xl px-5 py-10 text-center">
          <h3 className="text-3xl md:text-4xl text-gray-900 mb-6">
            Why Braiders Choose Woaom Web Design
          </h3>
          <ul className="text-gray-700 space-y-3 text-lg">
            <li>✨ Niche expertise in beauty & women‑owned businesses</li>
            <li>✨ Designs that look premium <span className="italic">and</span> convert visitors into bookings</li>
            <li>✨ Setup of booking, payments, Google reviews, and local SEO</li>
            <li>✨ Guidance from side‑hustle to fully booked braiding brand</li>
          </ul>
        </div>


  {/* Credibility: As Seen On / Brand list */}
 
          <Brandlist />
  
        {/* Call To Action */}
        <div className="text-center py-12">
          <h3 className="text-3xl md:text-4xl mb-4 text-gray-900">
            Ready to Launch Your Braiding Business Online?
          </h3>
          <p className="text-gray-700 mb-6">
            Don’t let potential clients scroll past you — let’s build the website and
            marketing system that makes your braiding business shine.
          </p>
          <a href="/contact">
            <button className="bg-[#C18343] text-white uppercase tracking-widest px-8 py-4 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
              Book Your Package Today →
            </button>
          </a>
          <p className="text-xs text-gray-600 mt-3">Limited spots available monthly • 100% satisfaction guarantee</p>
        </div>

        <PastWordBraids />
        <TestimonialsSection/>
        <BraiderFunnel/>
        <Footer />
      </section>
    </main>
  );
}

export default BraidersLandPage;